import { render, staticRenderFns } from "./stock_detail_online_selector.vue?vue&type=template&id=3738ec54&scoped=true"
import script from "./stock_detail_online_selector.vue?vue&type=script&lang=js"
export * from "./stock_detail_online_selector.vue?vue&type=script&lang=js"
import style0 from "./stock_detail_online_selector.vue?vue&type=style&index=0&id=3738ec54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738ec54",
  null
  
)

export default component.exports